import { JsonViewer, JsonViewerProps } from '@textea/json-viewer';
import styled, { css } from 'styled-components';
import { convertStyleObjectToCSSString } from 'app/shared/utils/react';
import { useTheme } from '@mui/styles';

export interface U21JsonViewerProps extends Omit<
  JsonViewerProps,
  'rootName' | 'value' | 'onCopy' | 'theme'
> {
  data: object | object[];
  isDefaultCollapsed?: boolean;
}

// API reference: https://viewer.textea.io/apis
export const U21JsonViewer = ({
  data,
  isDefaultCollapsed,
  defaultInspectDepth,
  ...rest
}: U21JsonViewerProps) => (
  <StyledJsonViewer
    {...rest}
    rootName={false}
    value={data}
    defaultInspectDepth={isDefaultCollapsed ? 0 : defaultInspectDepth}
  />
);

const JsonViewerThemeWrapper = (props: JsonViewerProps) => {
  const {
    palette: { mode },
  } = useTheme();
  return <JsonViewer theme={mode} {...props} />;
};

const StyledJsonViewer = styled(JsonViewerThemeWrapper)`
  padding: 8px;

  ${(props) => css`
    background-color: ${props.theme.palette.background.neutral};
    border-radius: ${props.theme.shape.borderRadius}px;
  `}

  ${(props) => convertStyleObjectToCSSString(props.theme.typography.body2)};
`;
